import Header from '../../../../../components/Header';
import { Button } from 'antd';
import ContainerWrapper
  from '../../../../../components/ContainerWrapper/container-wrapper.component';
import { CloseOutlined } from '@ant-design/icons';
import Title from '../../../../../components/title/title.component';
import '../lancamento-aula.styles.scss';
import AulaInformacaoBox
  from '../../../components/aula-informacao-box/aula-informacao-box.component';
import StepsBox from '../../../components/steps-box/steps-box.component';
import useBackClassroomPage from '../../../hooks/use-back-classroom-page.hook';
import ConteudoMinistradoForm
  from './components/conteudo-ministrado-form/conteudo-ministrado-form.component';
import useLancamentoAulaStep1 from './use-lancamento-aula-step-1.hook';
import { useTranslation } from 'react-i18next';
import StudentAccordion
  from '../../../components/student-accordion/student-accordion.component';
import AulaNaoOcorridaModal
  from './components/aula-nao-ocorrida-modal/aula-nao-ocorrida-modal.component';
import useRegistrarAulaNaoOcorrida
  from './hooks/use-registrar-aula-nao-ocorrida.hook';

export default function LancamentoAulaStep1() {
  const { backClassroomPage } = useBackClassroomPage();
  const {
    formObject,
    relatorioFrequencias,
    isConteudoRegistered,
    form
  } = useLancamentoAulaStep1();
  const { t } = useTranslation(['gestao_de_aulas']);
  const aulaNaoOcorrida = useRegistrarAulaNaoOcorrida();

  return (
    <>
      <Header />
      <ContainerWrapper hasHeader>
        <div className="lancamento-aula__title-button">
          <Title title={t('gestao_de_aulas:taughtContent')} />
          <Button
            onClick={backClassroomPage}
            className="button-second"
            style={{ width: '40px', height: '40px' }}
            icon={<CloseOutlined />}
          />
        </div>

        <div className="lancamento-aula-wrapper">
          <div className="lancamento-aula-wrapper__aula-information-steps-container">
            <AulaInformacaoBox />
            <StepsBox
              current={isConteudoRegistered ? 1 : 0}
              title={t('gestao_de_aulas:launchLesson')}
            />
          </div>

          <div className="lancamento-aula-wrapper__title-conteudo-ministrado-form">
            <ConteudoMinistradoForm
              {...formObject}
              onAulaNaoOcorrida={aulaNaoOcorrida.show}
            />

            <div
              className={[
                'lancamento-aula-wrapper__frequencias-section',
                !isConteudoRegistered
                  ? 'lancamento-aula-wrapper__disabled-section'
                  : ''
              ].join(' ').trim()}
            >
              <Title title={t('gestao_de_aulas:frequenciesAndSkills')} />
              {relatorioFrequencias.map((relatorioFrequencia, index) => (
                <StudentAccordion
                  key={index}
                  relatorio={relatorioFrequencia}
                  form={form}
                />
              ))}
            </div>
          </div>
        </div>
      </ContainerWrapper>
      <AulaNaoOcorridaModal
        open={aulaNaoOcorrida.open}
        loading={aulaNaoOcorrida.loading}
        onCancel={aulaNaoOcorrida.close}
        onSubmit={aulaNaoOcorrida.submit}
      />
    </>
  );
}
